import React, {useEffect, useRef, useState} from 'react';
import DataTable from './DataTable';
import defaultStyles from './styles';
import TopToolbar from './TopToolbar';
import constructComponents from './CustomComponents/constructComps';
import {DataTableContext} from './Utils/DataTableContext';
import {DragTableContextProvider} from './Utils/DragTableContext';
import Head from './Head';

const Deploy = props => {

  // styles
  let styles = {...defaultStyles};
  const tableRef = useRef();
  const [maxWidth, setMaxWidth] = useState(null);
  const windowWidthRef = document.body.clientWidth;
  // width of the table element for measurements

  if (tableRef.current && maxWidth === null) {
    const tableBounds = tableRef.current.getBoundingClientRect();
    const tableWidth = tableBounds.right - tableBounds.left;
    const value = Math.floor(tableWidth);
    setMaxWidth(value);
  }
  // merge custom styles into component styles if set in props
  if (props.styles) {
    Object.keys(props.styles).key(key => {
      styles[key] = {...styles[key], ...props.styles[key]};
    });
  }

  // set controller from context
  const {setController, controller} = React.useContext(DataTableContext);
  const {settings, options, headers} = props;
  React.useEffect(() => {
    if (controller === null) setController({
      input: null,
      stateUpdate: null,
      tableWidth: maxWidth,
      headers: headers,
      searchQuery: null,
      tableElement: tableRef,
      headerSettings: settings && settings.headers ? settings.headers : null,
      options: options,
    })

  }, [settings, options, headers, controller, setController, maxWidth])
  // controller state store

  if (controller && controller.handlingUpdate && props.data !== null && !props.refreshing) {
    controller.registerData(props.data);
    controller.updateStore.tableData = controller.data.slice();
    controller.render(true);
    controller.handlingUpdate = false;
  }


  if (controller) controller.handleGroupAction = (actionInfo) => {
    const gParams = {
      params: actionInfo.actionParams,
      groupData: controller.group.map(dataID => controller.master[dataID]),
      controller: controller,
    }
    controller.groupActions[actionInfo.actionID].action(gParams);
    controller.stateUpdate({tableData: null})
    controller.handlingUpdate = true;
  }

  // fetch param change
  const handleFetchParamChange = param => {
    controller.clearGroup();
    if (props.fetchParamChange) props.fetchParamChange(param);
  }

  // resize listener
  if (controller
    && controller.data
    && tableRef.current
    && maxWidth !== null
    && maxWidth !== controller.tableWidth
  ) {
    controller.tableWidth = maxWidth;
    controller.calculateColumns();
  }
  // mount/unmount resize event listener
  const resizeResponse = () => setMaxWidth(null);
  useEffect(() => {
    window.addEventListener('resize', resizeResponse);
    return(() => window.removeEventListener('resize', resizeResponse))
  }, [])
  // resize on data change
  // the props.routeState is passed in because on the parent sidebar
  // there is no data so as to which the resize is not fired for parent navigation
  useEffect(() => {resizeResponse()}, [props.data, props.routeState])

  const changeTracker = useRef({
    columns: props.options ? props.options.columns : null,
  })
  // recalculate widths after columns options change
  if (props.options && props.options.columns) {
    if (changeTracker.current.columns !== props.options.columns) {
      console.log(changeTracker.current, props.options, 'test')
      controller.userSetColumns = props.options.columns;
      controller.calculateColumns();
      controller.render(true);
      changeTracker.current.columns = props.options.columns;
    }
  }


  // custom comp
  const CustomComponents = constructComponents({
    controller: controller,
    components: props.customComponents,
    default: {
      location: props.location,
      history: props.history,
      refresh: props.dataRefresh,
      type: props.memo
    }
  });
  const dataLength = controller && controller.data ? controller.data.length : 0;
  return (
    <div id={controller ? controller.tableID : null}>

    {/* Custom Component - top */}
    {CustomComponents.top && CustomComponents.top.component &&
      <div style={{ margin: '0 auto'}}>
        <CustomComponents.top.component
          {...CustomComponents.top.props}
        />
      </div>
    }

    {/* Head */}
      {(!props.minDisplay && !props.noSearch) && <Head
        customComponents={CustomComponents}
        options={props.options}
      />}

    {/* Top Toolbar - tabs - fetch param options */}
    {props.tabSettings && props.tabSettings.paramOptions &&
      <TopToolbar
        settings={props.tabSettings}
        activeUserParam={props.activeFetchParam}
        width={controller && controller.tableWidth ? controller.tableWidth - 15 + 'px' : '100%'}
        tableElement={tableRef}
      />
    }

    {/* Table */}
    <div style={styles.wrapper} ref={tableRef}>
      {/* DataTable Body */}
      <div style={{
          ...styles.container,
          width: maxWidth ? maxWidth + 'px' : 'auto',
          maxWidth: '100%',
          minHeight: dataLength < 8 ? 450 : 'auto',
          background: dataLength < 8 ? 'none' : styles.container.background,
        }}
      >
        <div style={styles.headerBackground}/>
        <DragTableContextProvider dataTableID={props.tableID || 'dt_instance_0'}>
        {controller
          ? <DataTable
              {...props}
              controller={controller}
              styles={styles}
              tableWidth={maxWidth}
              tableElement={tableRef}
              options={props.options || {}}
            />
          : null}
        </DragTableContextProvider>
      </div>
      {/* Custom Component - bottom */}
      {CustomComponents.bottom && CustomComponents.bottom.component &&
        <CustomComponents.bottom.component
            {...CustomComponents.bottom.props}
        />
      }
      {props.refreshing && <div style={styles.updateOverlay}/>}
    </div>
  </div>
  );
}

export default Deploy;
